import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-article-line"></i>
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">深度专题报道</h2>
          <p className="mt-3 text-sm text-foreground-600">全方位视角，深度还原赛事内幕</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              } ${i === 1 ? 'lg:col-span-1' : ''}`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[21/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
                <div className="mt-4">
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-500 group-hover:gap-2 transition-all">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}